/**
 * MODULE: AssistantFormRequestCard.tsx
 * PURPOSE: Single entry for inline assistant form_request rendering (golden-path routing).
 */

import type { FormRequest } from '../../hooks/assistant/types';
import {
  isEmailTemplateEditFormCatalogRequest,
  isEmailTemplateFormCatalogRequest,
  isSalesTargetFormCatalogRequest,
} from './assistantFormRequestUtils';
import { EmailTemplateEditFormCatalogBridge } from './EmailTemplateEditFormCatalogBridge';
import { EmailTemplateFormCatalogBridge } from './EmailTemplateFormCatalogBridge';
import { SalesTargetFormCatalogBridge } from './SalesTargetFormCatalogBridge';
import { FormCard } from './FormCard';

type AssistantFormRequestCardProps = {
  formRequest: FormRequest;
  onSubmit: (data: Record<string, unknown>) => void;
  onCancel: () => void;
  disabled?: boolean;
};

export function AssistantFormRequestCard({
  formRequest,
  onSubmit,
  onCancel,
  disabled = false,
}: AssistantFormRequestCardProps) {
  if (isEmailTemplateEditFormCatalogRequest(formRequest)) {
    return (
      <EmailTemplateEditFormCatalogBridge
        formRequest={formRequest}
        onCancel={onCancel}
        disabled={disabled}
      />
    );
  }
  if (isEmailTemplateFormCatalogRequest(formRequest)) {
    return (
      <EmailTemplateFormCatalogBridge
        formRequest={formRequest}
        onSubmit={onSubmit}
        onCancel={onCancel}
        disabled={disabled}
      />
    );
  }
  if (isSalesTargetFormCatalogRequest(formRequest)) {
    return (
      <SalesTargetFormCatalogBridge
        formRequest={formRequest}
        onCancel={onCancel}
        disabled={disabled}
      />
    );
  }
  return (
    <FormCard
      formRequest={formRequest}
      onSubmit={onSubmit}
      onCancel={onCancel}
      disabled={disabled}
    />
  );
}
